import { render } from "./CustomIcon.vue?vue&type=template&id=3d692a2f"
import script from "./CustomIcon.vue?vue&type=script&lang=js"
export * from "./CustomIcon.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__